import { getAppConfiguration } from "../../Config";
import { interceptFetch } from "../InterceptFetch";
import {ALL_ROLE, ALL_USERS, CREATE_USER, CUSTOMER, DELETE_USER, DETAIL_USER, INPERSONATE, LIST_USERS, UPDATE_USER, USER, USERS} from './Component/EndPointServices';
import { AuthHeaders } from "./Component/authHeader";
const mlsApiLocal = getAppConfiguration().mlsApiUrl;
class Users {
    GETACCESSTOKEN= async(instance:any,request:any)=>{
        try{
            let accessToken:any = ''
           await instance.acquireTokenSilent(request).then((accessTokenResponse:any) => {
                accessToken =accessTokenResponse.accessToken
            }).catch((error:any) => {
                console.log(error,"access token")
            });
            return accessToken
        }catch(error){console.log("access token error",error)}
        }
    USER_LIST = async(customerId:any, accessToken:string)=>{
        let usersUrl = CUSTOMER+customerId+USERS;
        const headers = AuthHeaders(accessToken);
        const options = {method: "GET",headers: headers};
        try{
            const getUserList = await interceptFetch(mlsApiLocal+usersUrl,options).catch(err=>{console.log("the error user list  ==>",err)})
           return getUserList;
        }catch(error){console.log('list of the user list error==>',error)} 
    };
    INPERSONATE_LIST = async( accessToken:string)=>{
        let usersUrl = USER+INPERSONATE;
        const headers = AuthHeaders(accessToken);
        const options = {method: "GET",headers: headers};
        try{
            const getUserList = await interceptFetch(mlsApiLocal+usersUrl,options).catch(err=>{console.log("the error user list  ==>",err)})
           return getUserList;
        }catch(error){console.log('list of the user list error==>',error)} 
    };
    ALL_GET_USER = async(accessToken:string)=>{
        let usersUrl = ALL_USERS;
        const headers = AuthHeaders(accessToken);
        const options = {method: "GET",headers: headers};
        try{
            const allgetList = await interceptFetch(mlsApiLocal+usersUrl,options).catch(err=>{console.log("the error all user list  ==>",err)})
           return allgetList;
        }catch(error){console.log('list of the all user list error==>',error)} 
    };
    USER_DETAILS = async(userId:any,accessToken:string)=>{
        const headers = AuthHeaders(accessToken);
        const options = {method: "GET",headers: headers};
        try{
        const usersDetails =  await interceptFetch(mlsApiLocal+DETAIL_USER+userId, options).catch(err=>{console.log("the error user detail ==>",err)});
            return usersDetails;
        }catch(error){console.log('list of the user detail error==>',error)} 
    };
    GET_ROLE = async (userId:string,accessToken:string) =>{
        const headers = AuthHeaders(accessToken);
        const options = {method: "GET",headers: headers};
       try{
        const role = await interceptFetch(mlsApiLocal+ALL_ROLE+userId,options).catch(err=>{console.log("the error get role  ==>",err)});
        return role;
       }catch(error){console.log('list of the user role error==>',error)} 
    };
    ALL_USERS = async (param:any, accessToken:string,instance:any,enqueueSnackbar:any) => {
        const headers = AuthHeaders(accessToken);
        const options = {method: "POST",body:JSON.stringify(param),headers: headers};
        try{
            const allUser =  await interceptFetch(mlsApiLocal+USER+"authenticate", options).catch(err=>{
                enqueueSnackbar('Servern är fel Logga inte in',{variant:'error'});
                //instance.logoutRedirect();
                //localStorage.clear();
            });
            return allUser;
        }catch(error){enqueueSnackbar(error,{ variant: 'error'} )}
    };
    DELETE_USER = async(userId:any, accessToken:string) => {
        const headers = AuthHeaders(accessToken);
        const options = { method: "DELETE",headers: headers};
        try{
            const delete_User = await interceptFetch(mlsApiLocal+DELETE_USER+userId, options).catch(err=>{console.log("the error user delete  ==>",err)})
            return delete_User;
        }catch(error){console.log('list of the delete User ==>',error)}
    };
    UPDATE_USER = async(userid:any,userData:any,accessToken:string) => {
        const headers = AuthHeaders(accessToken);
        const options = {method: "PUT", body:JSON.stringify(userData),headers: headers};
        try{
            const update_User =  await interceptFetch(mlsApiLocal+UPDATE_USER + userid, options).catch(err=>{console.log("the error user update  ==>",err)});
            return update_User;
        }catch(error){console.log('list of the update User ==>',error)}
    };
    CREATE_USER = async(userData:any,accessToken:string) => {
        const headers = AuthHeaders(accessToken);
        const options = {method: "POST",body:JSON.stringify(userData),headers: headers};
        try{
            const userCreate =  await interceptFetch(mlsApiLocal+CREATE_USER, options).catch(err=>{console.log("the error user create  ==>",err)});
            return userCreate;
        }catch(error){console.log('list of the create User ==>',error)}
    };
}
export default new Users();